module.exports = __webpack_public_path__ + "static/nfr-44a87034b4da19a096f95d077e93b96c.png";